import React from "react";

import RadioGroupControl from "@visa/vds/radio-group-control";
import Radio from "@visa/vds/radio";
import Typography from "@visa/vds/typography";
import Divider from "@visa/vds/divider";
import Grid from "@visa/vds/grid";
import Row from "@visa/vds/row";
import Col from "@visa/vds/col";
import { EmailNotificationEvent, EmailNotificationEventType } from "_constants/EmailNotificationConstants";
import { useHistory } from "react-router-dom";
import { UserSettingRoutes } from "_constants/PageRoutes";
import { trackPromise } from "react-promise-tracker";
import { EmailNotificationApi } from "services/emailNotification.service";
import { GlobalAlertContext } from "context/GlobalAlertContext";

const EventInformation = (props) => {
  const { serviceData, serviceIdx, setServiceData, alertObj } = props;
  const history = useHistory();
  const updateCustomDescription = (eventIdx, value) => {
    let newServices = [...serviceData];
    let currentService = newServices[serviceIdx];
    let updatedEvent = {
      ...currentService.emailNotificationUsers[eventIdx],
      frequency: value,
    };
    currentService.emailNotificationUsers[eventIdx] = updatedEvent;
    newServices[serviceIdx] = currentService;
    setServiceData(newServices);
  };

  const updateUserPreference = (eventId, receiveEmailNotifications) => {
    let newServices = [...serviceData];
    let currentService = newServices[serviceIdx];
    currentService.emailNotificationUsers[eventId].receiveEmailNotifications = receiveEmailNotifications;

    if (receiveEmailNotifications && currentService.emailNotificationUsers[eventId].frequency == 0) {
      currentService.emailNotificationUsers[eventId].frequency = currentService.emailNotificationUsers[eventId].emailNotificationEvent.frequency;
    }

    setServiceData(newServices);
  }

  const addGroupDefaultText = (value, groupValue) => {
    return value === groupValue ? " (Group Default)" : "";
  };

  const updateSelectionOfVSSClientsPreference = (eventIdx, option) => {
    let newServices = [...serviceData];
    let currentService = newServices[serviceIdx];
    currentService.emailNotificationUsers[eventIdx].isSelectingVSSClients = (option);
    setServiceData(newServices);
  }
  const handleVSSClientsSelection = (eventId) => {
    selectVSSClientAction(eventId);
  };

  const selectVSSClientAction = (eventId) => {
    history.push({
      pathname: UserSettingRoutes.USER_EMAIL_NOTIFICATION_SELECTED,
      search: `?eventId=${eventId}`,
    });
    
    trackPromise(
      EmailNotificationApi.UpdateEmailNotificationUserFrequencies(serviceData)
          .then((response) => {
              if (!response.data.result) {
                  alertObj.setErrorMessage("Failed to update.")
              } else if (!response.data.success) {
                  alertObj.setErrorMessage(response.data.error);
              } else {
                  alertObj.setSuccessMessage("Email Notifications preferences in the previous page successfully saved.")
              }
          })
          .catch((error) => {
              alertObj.setErrorMessage('An error occured while udpating email notification preferences for : ' + error.message);
          })
  );
  };

  const shouldReceiveNotification = (emailNotificationUser) => {
    if (!emailNotificationUser?.receiveEmailNotifications) return false;

    const allowedEvents = [
      EmailNotificationEvent.CertificationPackageStateUpdateInternal,
      EmailNotificationEvent.DeferredPackageRequestReviewInternal,
      EmailNotificationEvent.VstsBaseSubscriptionExpirationReminderInternal,
      EmailNotificationEvent.VstsExtensionExpirationReminderInternal,
      EmailNotificationEvent.ComplianceLetterExpirationReminderInternal,
    ];

    return allowedEvents.includes(emailNotificationUser?.eventId);
  };

  return (
    <>
      <Grid>
        <Row>
          <Col>
            {serviceData[serviceIdx].emailNotificationUsers &&
              serviceData[serviceIdx].emailNotificationUsers.map(
                (emailNotificationUser, eventId) => (
                  <Col key={`testing-my-${eventId}`}>
                    <Row>
                      <Col>
                        <Typography className="vss-field-label">
                          <b>Description Text</b>
                        </Typography>
                        <Typography className="vss-field-label">
                          {emailNotificationUser?.emailNotificationEvent.name}
                        </Typography>
                      </Col>
                      <Col>
                        <Typography>
                          <b>Configure User Preference</b>
                        </Typography>
                        <RadioGroupControl
                          key={`${eventId}-user-preference-radio-group`}
                          value={emailNotificationUser?.receiveEmailNotifications}
                          onChange={(e) => updateUserPreference(eventId, e.target.value === "true")}
                        >
                          <Radio
                            name={`user-preference-${serviceIdx}-${eventId}-yes`}
                            value={true}
                            key={`user-preference-radio-${serviceIdx}-${eventId}-1`}
                            id={`user-preference-radio-control-${serviceIdx}-${eventId}-1`}
                            label={
                              "Yes, I want to receive the email notifications"
                            }
                          />
                          <Radio
                            name={`user-preference-${serviceIdx}-${eventId}-no`}
                            value={false}
                            key={`user-preference-radio-${serviceIdx}-${eventId}-2`}
                            id={`user-preference-radio-control-${serviceIdx}-${eventId}-2`}
                            label={
                              "No, I do not want to receive the email notifications"
                            }
                          />
                        </RadioGroupControl>
                        {shouldReceiveNotification(emailNotificationUser) && (
                          <>
                            <Typography className="vss-field-label">
                              <b>For Internal user only</b>
                            </Typography>
                            <RadioGroupControl
                              key={eventId}
                              value={emailNotificationUser?.isSelectingVSSClients.toString()}
                              legend={
                                ""
                              }
                              onChange={(e) => updateSelectionOfVSSClientsPreference(eventId, e.target.value === "true")}
                            >
                              <Radio
                                name={`isSelectingVSS-preference-${serviceIdx}-${eventId}-yes`}
                                value={"false"}
                                key={`isSelectingVSS-preference-radio-${serviceIdx}-${eventId}-1`}
                                id={`isSelectingVSS-preference-radio-control-${serviceIdx}-${eventId}-1`}
                                label={"All VSS Clients"} />
                              <Radio
                                name={`isSelectingVSS-preference-${serviceIdx}-${eventId}-no`}
                                value={"true"}
                                key={`isSelectingVSS-preference-radio-${serviceIdx}-${eventId}-2`}
                                id={`isSelectingVSS-preference-radio-control-${serviceIdx}-${eventId}-2`}
                                label={
                                  <>
                                    {"Selected VSS Clients    "}
                                    {emailNotificationUser?.isSelectingVSSClients && (
                                      <a
                                        onClick={() => handleVSSClientsSelection(emailNotificationUser?.eventId)}
                                      >
                                        {"Your VSS Client List >"}
                                      </a>
                                    )}
                                  </>
                                } />

                            </RadioGroupControl>
                          </>
                        )}
                        {emailNotificationUser?.receiveEmailNotifications &&
                          emailNotificationUser?.emailNotificationEvent
                            .emailType === EmailNotificationEventType.Recurring && (
                            <>
                              <Typography className="vss-field-label">
                                <b>Email Notification Frequency</b>
                              </Typography>
                              <RadioGroupControl
                                key={eventId}
                                value={emailNotificationUser?.frequency.toString()}
                                legend={
                                  "This overrides the email frequency from the group default."
                                }
                                onChange={(e) =>
                                  updateCustomDescription(
                                    eventId,
                                    parseInt(e.target.value)
                                  )
                                }
                              >
                                <Radio
                                  name={`event-frequency-${serviceIdx}-${eventId}-option-1`}
                                  value={"1"}
                                  key={`event-radio-${serviceIdx}-${eventId}-1`}
                                  id={`event-radio-control-${serviceIdx}-${eventId}-1`}
                                  label={
                                    "Hourly" +
                                    addGroupDefaultText(
                                      "1",
                                      emailNotificationUser?.emailNotificationEvent.frequency.toString()
                                    )
                                  }
                                />
                                <Radio
                                  name={`event-frequency-${serviceIdx}-${eventId}-option-2`}
                                  value={"2"}
                                  key={`event-radio-${serviceIdx}-${eventId}-2`}
                                  id={`event-radio-control-${serviceIdx}-${eventId}-2`}
                                  label={
                                    "Daily" +
                                    addGroupDefaultText(
                                      "2",
                                      emailNotificationUser?.emailNotificationEvent.frequency.toString()
                                    )
                                  }
                                />
                                <Radio
                                  name={`event-frequency-${serviceIdx}-${eventId}-option-3`}
                                  value={"3"}
                                  key={`event-radio-${serviceIdx}-${eventId}-3`}
                                  id={`event-radio-control-${serviceIdx}-${eventId}-3`}
                                  label={
                                    "Weekly" +
                                    addGroupDefaultText(
                                      "3",
                                      emailNotificationUser?.emailNotificationEvent.frequency.toString()
                                    )
                                  }
                                />
                              </RadioGroupControl>
                            </>
                          )}
                        {emailNotificationUser?.receiveEmailNotifications &&
                          emailNotificationUser?.emailNotificationEvent
                            .emailType === EmailNotificationEventType.Reminder && (
                            <>
                              <Typography className="vss-field-label">
                                <b>Email Notification Schedule</b>
                              </Typography>
                              <Typography className="vss-field-label">
                                {emailNotificationUser?.emailNotificationEvent.emailSchedule}
                              </Typography>
                            </>
                          )}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Divider type="standard" />
                      </Col>
                    </Row>
                  </Col>
                )
              )}
          </Col>
        </Row>
      </Grid>
    </>
  );
};

export default EventInformation;
